import clsx from 'clsx'
import { FC, useState } from 'react'

import { AccordionMenuProps } from '../../types'

import cl from './AccordionMenu.module.scss'
import { Swiper } from './assets/Swiper'

export const AccordionMenu: FC<AccordionMenuProps> = ({
	title,
	children,
	isActive = false,
	className
}) => {
	const [isOpen, setIsOpen] = useState(isActive)
	const handleClick = () => {
		setIsOpen(prevState => !prevState)
	}

	return (
		<div className={clsx(cl.main, className)}>
			<div className={cl.wrapper} onClick={handleClick}>
				<h4 className={cl.title}>{title}</h4>
				<Swiper className={clsx(cl.icon, { [cl.icon_open]: isOpen })} />
			</div>
			<div className={clsx(cl.content, { [cl.content_open]: isOpen })}>
				<div className={cl.innerContent}>{children}</div>
			</div>
		</div>
	)
}
